// import dayjs from '../lib/day.min.js'

export const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
export const formatLocation = (longitude, latitude) => {
    if (typeof longitude === 'string' && typeof latitude === 'string') {
        longitude = parseFloat(longitude)
        latitude = parseFloat(latitude)
    }

    longitude = longitude.toFixed(2)
    latitude = latitude.toFixed(2)

    return {
        longitude: longitude.toString().split('.'),
        latitude: latitude.toString().split('.')
    }
}
//时间戳转时间格式
export const timeToDate = time => {
    var date = new Date(time * 1000);//如果date为13位不需要乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
}
// const formatDatetimeS=date=>{
//   var m = moment( date|| new Date() );
//   return m.format('MM月DD日 HH:mm')
// }

//用户姓名汉字 2-10位
export const inputCheckChineseName = name => {
    if ((/^[\u4e00-\u9fa5]{2,10}$/.test(name))) {
        return true;
    }
    return false;
}

export const isCardCheck = card => {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card)) {
        return true;
    }
    return false;
}

export function existy(variableName) {
    try {
        if (typeof (variableName) == "undefined") {
            return false;
        } else {
            return true;
        }
    } catch (e) {
        return false;
    }

}

export function isValid(value) {
    if (value === null || value == '') {
        return false;
    }
    return existy(value);
}

//验证手机号
export function inputCheckPhone(value) {
    if ((/^1[3456789]\d{9}$/.test(value))) {
        return true;
    }
    return false;
}
// function getDateMinute(time){
//     return dayjs(time).format("HH:mm")
// }
// function getCountDown(time){
//     var endTime=dayjs(time).add(30,'minute').unix();
//     var nowDate = dayjs().unix();
//     var diff=endTime-nowDate;
//     if(diff<=0) return '';
//     let minute = parseInt(diff/60);
//     let second = parseInt(diff%60);
//     return formatNumber(minute) + '分' + formatNumber(second)+'秒'
// }

//把obj对象里的值覆盖到newobj里面
export function deepCopy(newobj, obj) {
    if (typeof obj != 'object') {
        return obj;
    }
    for (var attr in obj) {
        var a = {};
        if (newobj[attr]) {
            a = newobj[attr];
        }
        newobj[attr] = deepCopy(a, obj[attr]);
    }
    return newobj;
}
export function getQueryString(name,url=window.location.serach) {
    var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
    var r = url.substr(1).match(reg)
    if (r != null) {
        return r[2]
    }
    return null;
}
//货币格式化
export function formatMoney(number, places, symbol, thousand, decimal) {
    number = number || 0;
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "$";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}


// 商品列表排列方式  1：多个一行 2：一个一行
export const goodsStyle = 1;

// 连接的公共跳转方式
export const linkCommon = (v, parent) =>{
    console.log(v)

    if(!v.linkType || !v.linkValue) {
        return
    }
    if(v.linkType == 1) { // URL连接
        window.open(v.linkValue,'_blank')
        return
    } 

    if(v.linkType == 2) { // 商品
        const {href} = parent.$router.resolve({
            name: 'detail',
            params: {goodsId: v.linkValue}
        })
        window.open(href, '_blank')
        return
    } 

    if(v.linkType == 3) { // 文章
        const { href } = parent.$router.resolve({
            name: 'helpdetail',
            query: {article_id: v.linkValue}
        })
        window.open(href, '_blank')
        return
    } 

    if(v.linkType == 4) { // 文章分类
        const { href } = parent.$router.resolve({
            name: 'help',
            query: {type_id: v.linkValue}
        })
        window.open(href, '_blank')
        return
    } 
	
			console.log(v.linkType);
    if(v.linkType == 5) { // 照片墙
        const { picture } = parent.$router.resolve({
            name: 'picture',
            query: {type_id: v.linkValue}
        })
        window.open(href, '_blank')
        return
    } 

}

export const checkPlate = () => {
    return  navigator.userAgent.match(/(MIDP|WAP|UP.Browser|Smartphone|Obigo|Mobile|AU.Browser|wxd.Mms|WxdB.Browser|CLDC|UP.Link|KM.Browser|UCWEB|SEMC-Browser|Mini|Symbian|Palm|Nokia|Panasonic|MOT-|SonyEricsson|NEC-|Alcatel|Ericsson|BENQ|BenQ|Amoisonic|Amoi-|Capitel|PHILIPS|SAMSUNG|Lenovo|Mitsu|Motorola|SHARP|WAPPER|LG-|LG|EG900|CECT|Compal|kejian|Bird|BIRD|G900\/V1.0|Arima|CTL|TDG|Daxian|DAXIAN|DBTEL|Eastcom|EASTCOM|PANTECH|Dopod|Haier|HAIER|KONKA|KEJIAN|LENOVO|Soutec|SOUTEC|SAGEM|SEC-|SED-|EMOL-|INNO55|ZTE|iPhone|Android|Windows CE|Wget|Java|curl|Opera|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export const redicectCheck = (v, parent) =>{ 
    let flag = navigator.userAgent.match(/(MIDP|WAP|UP.Browser|Smartphone|Obigo|Mobile|AU.Browser|wxd.Mms|WxdB.Browser|CLDC|UP.Link|KM.Browser|UCWEB|SEMC-Browser|Mini|Symbian|Palm|Nokia|Panasonic|MOT-|SonyEricsson|NEC-|Alcatel|Ericsson|BENQ|BenQ|Amoisonic|Amoi-|Capitel|PHILIPS|SAMSUNG|Lenovo|Mitsu|Motorola|SHARP|WAPPER|LG-|LG|EG900|CECT|Compal|kejian|Bird|BIRD|G900\/V1.0|Arima|CTL|TDG|Daxian|DAXIAN|DBTEL|Eastcom|EASTCOM|PANTECH|Dopod|Haier|HAIER|KONKA|KEJIAN|LENOVO|Soutec|SOUTEC|SAGEM|SEC-|SED-|EMOL-|INNO55|ZTE|iPhone|Android|Windows CE|Wget|Java|curl|Opera|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    console.log(window.location)
    let url = window.location.pathname+''+window.location.search;
    url = url.toLowerCase();
    let transform = [
        {wapUrl:"/wap/pagelogin/login/index1?invitecode=",pcUrl:"/web/?invite="},
        {wapUrl:"/wap/pages/goods/index/index?id=",pcUrl:"/web/detail/"},
        {wapUrl:"/wap/pages/classify/index?id=",pcUrl:"/web/search?id="},
    ];
    
    for(let key  in transform){
        let mobile = flag;
        let wapPattern = transform[key].wapUrl;
        var wapIndex = url.indexOf(transform[key].wapUrl);
        var pcIndex = url.indexOf(transform[key].pcUrl);
        let wapId = url.replace(transform[key].wapUrl,'');
        let pcId = url.replace(transform[key].pcUrl,'');
        
        if(!mobile && typeof(mobile)!="undefined" && mobile!=0){//当前PC端
            console.log('pc', pcIndex, wapIndex, pcIndex==-1 && wapIndex >-1)
            if(pcIndex==-1 && wapIndex >-1){
                window.location.href = transform[key].pcUrl+wapId;
                return;
            }
        }else{ //当前H5端
            // if((window.location.origin + '/web/' == window.location.href) 
            //     || window.location.origin + '/web' == window.location.href) {

            //     window.location.href = window.location.origin + '/wap/pagelogin/login/index1/' + window.location.search
            //     console.log(213213, window.location.href)

            //     return 
            // }
            if(pcIndex>-1 && wapIndex ==-1){
                window.location.href = transform[key].wapUrl+pcId;
                return;
            }
        }
    }
}